export default "__VITE_ASSET__CYiwps32__"